var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"responsive-iframe",attrs:{"src":`${
        _vm.$i18n.locale == 'hu'
        ? 'https://www.youtube.com/embed/UCr1FYnApBo?cc_lang_pref=hu&cc_load_policy=1'
        : 'https://www.youtube.com/embed/UCr1FYnApBo'
      }`,"title":"YouTube video player","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":"","height":"450"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }